import { __assign, __extends, __rest } from "tslib";
import React from "react";
import { Components, Utils } from "@singularsystems/neo-core";
import { TabManager } from './TabManager';
var TabContextParams = /** @class */ (function () {
    function TabContextParams() {
        /**
         * True if the tab manager was passed in to the tab container.
         */
        this.isUserTabManager = false;
        this.inHeader = true;
    }
    return TabContextParams;
}());
export { TabContextParams };
export var TabContext = React.createContext(new TabContextParams());
var TabContainer = /** @class */ (function (_super) {
    __extends(TabContainer, _super);
    function TabContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.tabContext = new TabContextParams();
        var tabManager;
        if (_this.props.tabManager) {
            tabManager = _this.props.tabManager;
            _this.tabContext.isUserTabManager = true;
        }
        else {
            tabManager = new TabManager("", true, _this.props.selectedTab);
        }
        _this.tabManager = tabManager;
        _this.tabContext.tabManager = _this.tabManager;
        return _this;
    }
    TabContainer.prototype.componentDidMount = function () {
        this.tabManager.initialise();
    };
    TabContainer.prototype.componentWillUnmount = function () {
        this.tabManager.onUnmount();
    };
    TabContainer.prototype.render = function () {
        var _a = this.props, tabManager = _a.tabManager, selectedTab = _a.selectedTab, variant = _a.variant, fillMode = _a.fillMode, align = _a.align, verticalSizes = _a.verticalSizes, keepMounted = _a.keepMounted, domProps = __rest(_a, ["tabManager", "selectedTab", "variant", "fillMode", "align", "verticalSizes", "keepMounted"]);
        this.tabContext.keepMounted = keepMounted;
        if (!verticalSizes)
            verticalSizes = {};
        if (!verticalSizes.xs)
            verticalSizes.xs = 12;
        var isCardMode = (variant === "tabs" || !variant);
        if (variant === "flat") {
            variant = "tabs";
        }
        var _b = Components.BootstrapHelpers.getInverseBreakpointClasses(verticalSizes), cols = _b.cols, inverseCols = _b.inverseCols;
        domProps.className = Utils.joinWithSpaces(domProps.className, "row neo-tab-container", isCardMode ? "neo-tab-card-mode" : undefined);
        return (React.createElement(TabContext.Provider, { value: this.tabContext },
            React.createElement("div", __assign({}, domProps),
                React.createElement("div", { className: "tabs-header " + cols },
                    React.createElement(TabSection, { isHeader: true, containerProps: { verticalSizes: verticalSizes, variant: variant, fillMode: fillMode, align: align } }, this.props.children)),
                React.createElement("div", { className: inverseCols },
                    React.createElement(TabSection, { isHeader: false }, this.props.children)))));
    };
    return TabContainer;
}(React.Component));
export default TabContainer;
var TabSection = /** @class */ (function (_super) {
    __extends(TabSection, _super);
    function TabSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabSection.prototype.render = function () {
        this.context.inHeader = this.props.isHeader;
        var headerClassName = "nav ";
        if (this.props.isHeader) {
            var containerProps = this.props.containerProps;
            if (containerProps.verticalSizes) {
                var breakpoint = Components.BootstrapHelpers.getFirstBreakpoint(containerProps.verticalSizes);
                if (breakpoint)
                    headerClassName += " flex-" + breakpoint + "-column";
            }
            if (containerProps.variant !== "none") {
                headerClassName += " nav-" + (containerProps.variant || "tabs");
            }
            if (containerProps.fillMode) {
                headerClassName += " nav-" + containerProps.fillMode;
            }
            if (containerProps.align) {
                headerClassName += " justify-content-" + containerProps.align;
            }
        }
        return (this.props.isHeader ?
            React.createElement("ul", { className: headerClassName }, this.props.children) :
            React.createElement("div", { className: "tab-content" }, this.props.children));
    };
    TabSection.contextType = TabContext;
    return TabSection;
}(React.PureComponent));
